<div class="wrapper flex flex-col gap-[40px]">
  @if (options.showHeading !== false) {
    <div class="heading text-type-2"> {{ translations?.ReportActivity?.plurals?.one || 'Activity' }}</div>
  }
  <app-text-area
    [parentFormGroup]="form"
    controlName="title"
    label="detail"
    />
  @if (displayActivityType && activityTypeOptions?.length) {
    <app-dropdown
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['type']"
      [options]="activityTypeOptions"
      [parentFormGroup]="form"
      class="mb-[20px]"
      controlName="type"
      label="{{ translations?.ReportActivity?.plurals?.one || 'Activity' }} type"
      />
  }
  @if (mediaFiles?.length) {
    <app-pictures-section
      (onDelete)="deletePicture($event)"
      [isEditable]="editable && !options?.disabled"
      [pictures]="mediaFiles"
      class="pictures-section mb-[40px]"
      />
  }
  @if (showLocationSection()) {
    <app-location-station-card
      (onDelete)="deleteLocation()"
      [isEditable]="editable && !options?.disabled"
      [latitude]="form?.controls?.latitude?.value"
      [longitude]="form?.controls?.longitude?.value"
      [locationText]="form?.controls?.location?.value"
      [stationRange]="form?.controls?.station_range?.value"
      [form]="form"
      [recordLabel]="'activity'"
      class="location-section mb-[40px]"
      />
  }
  @if (options.showActionsSection === undefined || options.showActionsSection) {
    <app-actions-section
      [disableOptionMenu]="disableOptionMenu"
      class="actions-section w-[455px]"
      />
  }
</div>
